class SelectSearch extends Backbone.View {
	get events() {
		return ({
            'click .sma-select-menu': 'clickedContainer',
            'click .sma-select-row .sma-checkbox-input': 'selectOption',
            'input .sma-select-search': 'onSearchInput',
		});
	};

	initialize(config) {
        this.setElement($('body'));
    }

    clickedContainer(e) {
        e.stopPropagation();
    }

    selectOption(e) {
        let $target = $(e.currentTarget);
        $target.closest('.sma-select-content').find('.sma-checkbox-input').prop('checked', false);
        $target.prop('checked', true);
        $target.closest('.dropdown.show').removeClass('show');
		this.$el.find('.sma-select-dropdown-button').html($target.next().text());
    }

    onSearchInput(e) {
        let checkboxes = $(e.currentTarget).closest('.sma-select-menu').find('.sma-select-row');

        checkboxes.each((i, checkbox) => {
            if($(checkbox).find('label').text().toLowerCase().includes($('.sma-select-search').val().toLowerCase())) {
                $(checkbox).show();
            } else {
                $(checkbox).hide();
            }
        });
    }
}

module.exports = {
	SelectSearch,
};
